import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaPlus, FaList, FaImage, FaUserCheck, FaBriefcaseMedical, FaClipboardList } from 'react-icons/fa';
import { MdGroups, MdArticle } from 'react-icons/md';
import { LayoutDashboard, LogOut, Menu, Shield, ChevronLeft } from 'lucide-react';
import { auth } from '../firebase.config';
import { actionType } from '../context/Reducer';
import { useStateValue } from '../context/StateProvider';
import { signOut } from 'firebase/auth';
import { toast } from 'react-toastify';
import { BiMessageDetail } from "react-icons/bi";
import { BiCog } from "react-icons/bi";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [{ user }, dispatch] = useStateValue();

  const menuItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/dashboard' },
    { icon: FaImage, label: 'Add Slider', path: '/addSlider' },
    { icon: FaPlus, label: 'Add Consultant Job', path: '/createItem' },
    { icon: FaBriefcaseMedical, label: 'Add Careers Job', path: '/createcompanyItem' },
    { icon: FaList, label: 'View Jobs Details', path: '/viewItems' },
    { icon: FaClipboardList, label: 'View Jobs Application', path: '/view-application' },
    { icon: FaUserCheck, label: 'View Candidate', path: '/view-candidate' },
    { icon: MdGroups, label: 'Add Partner', path: '/addCompany' },
    { icon: MdArticle, label: 'Add Blogs', path: '/addBlogs' },
    { icon: BiMessageDetail, label: 'View Enquire', path: '/viewenquire' },
    { icon: BiCog, label: 'Add Services', path: '/Addservices' },
  ];

  const logout = async () => {
    try {
      const user = auth.currentUser;
      if (!user || !user.email) {
        console.warn("No logged-in user found or email is missing.");
        return;
      }
      localStorage.clear();
      dispatch({ type: actionType.SET_USER, user: null });
      toast.success("Successfully logged out!");
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error.message);
    }
  };
  return (
    <>
      <button
        className="lg:w-8 lg:h-8 w-6 h-6 lg:bg-white rounded-lg fixed top-4 left-4 z-50 lg:hidden"
        onClick={() => toggleSidebar(prev => !prev)}
      >
        {isOpen ? <Shield className="lg:h-5 lg:w-5 w-4 h-4 lg:block hidden text-[#005eb8]" /> : <Menu className='bg-[#005eb8] text-white' />}
      </button>

      <div className={`fixed left-0 top-0 h-full bg-[#005eb8] text-white transition-all duration-500 shadow-xl z-10 ease-in-out transform flex flex-col
        ${isOpen ? 'translate-x-0 w-56' : '-translate-x-full w-20'} lg:translate-x-0 overflow-y-auto`}> {/* Add overflow-y-auto here */}

        <div className="lg:p-6 p-2 text-center text-[16px] font-bold bg-[#005eb8] border-b border-gray-800">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Shield className="h-5 w-5 text-white" />
              <span className={`${!isOpen && 'hidden'}`}>Admin Panel</span>
            </div>
            <button onClick={() => toggleSidebar(!isOpen)} className="p-1 hover:bg-gray-700 rounded-lg">
              {isOpen ? <ChevronLeft className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          </div>
        </div>

        <nav className='flex-1 p-3'>
          <ul className='space-y-2'>
            {menuItems.map((item, index) => (
              <li key={index}>
                <Link
                  to={item.path}
                  className={`flex items-center gap-2 p-3 text-[13px] rounded-md transition-colors 
                    ${location.pathname === item.path ? 'bg-[#004e9a] text-blue-300' : 'hover:bg-[#004e9a]'}
                    ${!isOpen && 'justify-center'}`}
                >
                  <item.icon className="h-4 w-4" />
                  <span className={`${!isOpen && 'hidden'}`}>{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="p-4 border-t border-gray-800">
          <button className="flex items-center gap-3 p-3 text-sm rounded-md text-white hover:bg-[#004e9a] hover:text-blue-300 transition-colors w-full"
            onClick={logout}
          >
            <LogOut className="h-5 w-5" />
            <span className={`${!isOpen && 'hidden'}`}>Logout</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;